import { render, staticRenderFns } from "./ActivityDependentForm.vue?vue&type=template&id=4d88ab84&scoped=true&"
import script from "./ActivityDependentForm.vue?vue&type=script&lang=js&"
export * from "./ActivityDependentForm.vue?vue&type=script&lang=js&"
import style0 from "./ActivityDependentForm.vue?vue&type=style&index=0&id=4d88ab84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d88ab84",
  null
  
)

export default component.exports